module.exports = __webpack_public_path__ + "img/pdf-file-white.f295f8dd.svg";